import { render, staticRenderFns } from "./TripDetailContainer.vue?vue&type=template&id=3783e02b&scoped=true&"
import script from "./TripDetailContainer.vue?vue&type=script&lang=js&"
export * from "./TripDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./TripDetailContainer.vue?vue&type=style&index=0&id=3783e02b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783e02b",
  null
  
)

export default component.exports